import type { RefObject } from 'react';
import type { PrimaryLinkRef } from '../../atoms/primary-link/PrimaryLink.data';
import { findTransitionController } from '../../../util/core-transition-component';

interface CitiesNavigationRefs {
  createdByRef: RefObject<HTMLParagraphElement | null>;
  locationsRef: RefObject<Array<RefObject<PrimaryLinkRef | null>> | null>;
  exploreRef: RefObject<HTMLParagraphElement | null>;
  allWorkRef: RefObject<PrimaryLinkRef | null>;
  skipTransitionIn: boolean;
  onTransitionInComplete?: () => void;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  {
    createdByRef,
    locationsRef,
    exploreRef,
    allWorkRef,
    skipTransitionIn,
    onTransitionInComplete,
  }: CitiesNavigationRefs,
): void {
  if (skipTransitionIn) return;

  const createdByController = findTransitionController(createdByRef);
  const exploreController = findTransitionController(exploreRef);
  const allWorkController = findTransitionController(allWorkRef);

  timeline.add(createdByController?.getTimeline('in') as gsap.core.Timeline, '<0.1');

  locationsRef?.current?.forEach((locationRef) => {
    const locationController = findTransitionController(locationRef);
    if (locationController) {
      timeline.add(locationController.getTimeline('in') as gsap.core.Timeline, '<0.1');
    }
  });

  timeline.add(exploreController?.getTimeline('in') as gsap.core.Timeline, '<0.1');
  timeline.add(allWorkController?.getTimeline('in') as gsap.core.Timeline, '<0.1');
  if (typeof onTransitionInComplete === 'function') {
    timeline.call(onTransitionInComplete, undefined, '>');
  }
}
